<template>
  <footer class="bg-neutral text-neutral-content">
    
    <div class="max-w-7xl mx-auto px-4 py-12 md:py-16 flex flex-col lg:flex-row gap-10 lg:gap-20">
      
      <div class="flex flex-col items-center text-center">
        <div>
        <NuxtLink to="/shops">
        <img
          src="assets/images/logo.png"
          alt="Annza Logo"
          width="150"
            >
          </NuxtLink>
        </div>
        <h2 class="font-bold text-2xl tracking-wide mb-2">Aanza Restaurant  </h2>
        <p class="opacity-75 max-w-xs">
          Streamlining dining experiences, table management, and multi-vendor delivery since 2026.
        </p>
        <div class="flex gap-5 mt-10">
          <a href="#" class="hover:text-primary transition-colors">
            <span class="sr-only">Facebook</span>
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd" /></svg>
          </a>
          <a href="#" class="hover:text-primary transition-colors">
            <span class="sr-only">Twitter</span>
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" /></svg>
          </a>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-3 gap-8 lg:w-2/3 w-full">
        
        <nav class="flex flex-col gap-3">
          <h6 class="text-lg font-bold text-primary mb-2">Company</h6>
          <NuxtLink to="/about" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">About us</NuxtLink>
          <NuxtLink to="/contact" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">Contact</NuxtLink>
          <NuxtLink to="/careers" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">Careers</NuxtLink>
          <NuxtLink to="/partners" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">Our Partners</NuxtLink>
        </nav>

        <nav class="flex flex-col gap-3">
          <h6 class="text-lg font-bold text-primary mb-2">Legal</h6>
          <NuxtLink to="/terms" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">Terms of use</NuxtLink>
          <NuxtLink to="/privacy" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">Privacy policy</NuxtLink>
          <NuxtLink to="/cookies" class="link link-hover opacity-80 hover:opacity-100 hover:text-primary transition-colors">Cookie policy</NuxtLink>
        </nav>

        <nav class="flex flex-col gap-3 col-span-2 md:col-span-1 mt-4 md:mt-0">
          <h6 class="text-lg font-bold text-primary mb-2">Contact Us</h6>
          <a href="mailto:support@yoursystem.com" class="opacity-80 hover:opacity-100 flex items-center gap-2 transition-colors">
            <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
            info@aanzamenu.com
          </a>
          <a href="tel:+8801234567890" class="opacity-80 hover:opacity-100 flex items-center gap-2 transition-colors mt-2">
            <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
            +8801521-435356
          </a>
        </nav>

      </div>
    </div>    
  </footer>
</template>

<script setup>
// The year automatically updates in the copyright text via new Date().getFullYear()
</script>